import { SlackSenderLayout } from "../SlackSenderLayout";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSBox, NSBoxEntity, NSBoxString, NSBoxTextArea, NSButtonBlue, NSColumn, NSPanel, NSRow, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { SlackSenderRouterProps } from "../SlackSenderRouterProps";
import Styles from "./SendPage.module.css"
import { useRef } from "react";
import { ProviderRow } from "namirasoft-slack-sender";
import { useParams } from "react-router-dom";
import { SlackSenderRoutes } from "../SlackSenderRoutes";
import { FilterItem, FilterItemOperator } from "namirasoft-core";
import { NamirasoftMap } from "namirasoft-site-map";

export interface ISendPageProps extends NSARouterMakerResult, SlackSenderRouterProps
{ }

function SendPage(props: ISendPageProps)
{
	let NSBoxString_Channel = useRef<NSBoxString>(null);
	let NSBoxTextarea_Message = useRef<NSBoxTextArea>(null);
	let NSBoxEntity_Provider = useRef<NSBoxEntity<ProviderRow>>(null);

	let { id } = useParams();

	let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

	return (
		<SlackSenderLayout {...props}
			action={{
				title: "Send",
				description: "Enter the destination channel and your message to send a message via the selected provider.",
				menus: {}
			}}
		>
			<NSPanel>
				<NSColumn style={{ width: NSBox.width.double }}>
					<NSBoxEntity<ProviderRow>
						ref={NSBoxEntity_Provider}
						title="Provider"
						required
						multiple={false}
						table={namirasoft.slack_sender.tables.provider}
						getValue={item => item.id}
						getTitle={item => item.name}
						getSort={() => null}
						onLoaded={() =>
						{
							if (id)
								NSBoxEntity_Provider.current?.setValue(id);
						}}
                        info={{link: "https://namirasoft.com/slack-sender/console-guide/send/#field-provider-id"}}
					/>
					<NSBoxString
						ref={NSBoxString_Channel}
						title="Channel"
						classList={[Styles.send_page_message]}
						required={false}
						style={{ width: "100%" }}
                        info={{link: "https://namirasoft.com/slack-sender/console-guide/send/#field-channel-id"}}
					/>
					<NSBoxTextArea
						ref={NSBoxTextarea_Message}
						title="Message"
						required
						placeholder="Write your Message"
						style={{ width: "100%" }}
                        info={{link: "https://namirasoft.com/slack-sender/console-guide/send/#field-message"}}
					/>
					<NSSpace size={NSSpaceSizeType.MINI}
					></NSSpace>
					<NSRow>
						<NSButtonBlue title="Apply" onClick={{
							action: (onFinished) =>
							{
								try
								{
									let provider_id = NSBoxEntity_Provider.current?.getValueOne();
									if (provider_id)
									{
										let channel = NSBoxString_Channel.current?.getValue(false) ?? "";
										let message = NSBoxTextarea_Message.current?.getValue() ?? ""
										props.servers.slack_sender.slack.Send({ provider_id, channel, message }).then((res) =>
										{
											props.notifier.onSuccess("A message was sent successfully");

											let namirasoft = new NamirasoftMap(props.account.token_manager, props.notifier.onError);
											let filters = [new FilterItem(namirasoft.slack_sender.tables.sent, namirasoft.slack_sender.tables.sent.columns.id, false, FilterItemOperator.all.equals, res.id)];
											props.url.redirect(SlackSenderRoutes.SentList, { filters: FilterItem.encode(filters) });
											onFinished();
										}).catch(onFinished);
									}
								} catch (error)
								{
									props.notifier.onError(error as Error);
								}
								onFinished();
							}
						}} />
					</NSRow>
				</NSColumn>
			</NSPanel>
		</SlackSenderLayout>
	);
}

export default SendPage;